(function () {
  var STORAGE_KEY = 'mv_email_popup_dismissed_until';
  var root = document.querySelector('[data-email-popup]');
  if (!root) return;

  function isDismissed() {
    try {
      var until = localStorage.getItem(STORAGE_KEY);
      return !!until && Date.now() < Number(until);
    } catch (e) {
      return false;
    }
  }

  function remember(days) {
    try {
      localStorage.setItem(STORAGE_KEY, String(Date.now() + days * 24 * 60 * 60 * 1000));
    } catch (e) {}
  }

  function open() {
    root.classList.add('is-open');
    document.body.style.overflow = 'hidden';
  }

  function close(days) {
    root.classList.remove('is-open');
    document.body.style.overflow = '';
    remember(days || 7);
  }

  root.querySelectorAll('[data-email-popup-close]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      close(7);
    });
  });

  root.addEventListener('click', function (event) {
    if (event.target === root) close(7);
  });

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape' && root.classList.contains('is-open')) close(7);
  });

  var copyBtn = root.querySelector('[data-email-popup-copy]');
  if (copyBtn) {
    copyBtn.addEventListener('click', function () {
      var code = copyBtn.getAttribute('data-code') || '';
      if (!navigator.clipboard) return;
      navigator.clipboard.writeText(code).then(function () {
        var original = copyBtn.textContent;
        copyBtn.textContent = 'Copiado';
        setTimeout(function () {
          copyBtn.textContent = original;
        }, 2000);
      });
    });
  }

  if (root.querySelector('[data-auto-open]')) {
    remember(365);
    open();
    return;
  }

  if (!isDismissed()) {
    var segundos = parseInt(root.getAttribute('data-delay-seconds'), 10);
    if (!segundos || segundos < 1) segundos = 16;
    setTimeout(open, segundos * 1000);
  }
})();
